module.exports = __webpack_public_path__ + "static/media/menu_userProfileApproval_default.7ef2ffb5.svg";